import { render, staticRenderFns } from "./examineSoftInformation.vue?vue&type=template&id=318fbb2e&scoped=true"
import script from "./examineSoftInformation.vue?vue&type=script&lang=js"
export * from "./examineSoftInformation.vue?vue&type=script&lang=js"
import style0 from "./examineSoftInformation.vue?vue&type=style&index=0&id=318fbb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318fbb2e",
  null
  
)

export default component.exports